module.exports = __webpack_public_path__ + "img/footers-fresh.94f33897.png";